module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded === 'true') ? _c('main', {
    staticClass: "col-xs-12 corte mainslider"
  }, [_c('ul', _vm._l((_vm.slider.post_meta_fields._slide_de_imagenes), function(slide) {
    return _c('li', [_c('img', {
      attrs: {
        "src": slide.large,
        "alt": "",
        "width": "1400"
      }
    })])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b35ef24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slideportada.vue
// module id = 119
// module chunks = 0